/* eslint-disable max-classes-per-file */
import { Action } from '@ngrx/store';

export enum NvgActionTypes {
  OpenNvgConfirmationDialog = '[NVG] Open NVG confirmation dialog',
  UpdateNvgValues = '[NVG] Update NVG values for all crop fields',
}

export class OpenNvgConfirmationDialog implements Action {
  readonly type = NvgActionTypes.OpenNvgConfirmationDialog;
  constructor() {}
}

export class UpdateNvgValues implements Action {
  readonly type = NvgActionTypes.UpdateNvgValues;
  constructor() {}
}

export type AppActions = OpenNvgConfirmationDialog | UpdateNvgValues;
